import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "@emotion/styled";
import { useState, Fragment } from "react";
import { BackgroundMap } from "./BackgroundMap";
import { Spinner } from "./Spinner";
import { MapMarkerGreyFilled } from "./MapMarkerGreyFilled";
import { Trans } from "@lingui/react";
import { useElementsContext } from "../../elementsProvider";
// TODO extract to enviroment variable
const apiKey = "AIzaSyA72evBZVKJbP6rgoEW-r946TTI6JIN8Nk";
export function Map({ query }) {
    const { isMobile } = useElementsContext();
    const [isLoading, setLoading] = useState(true);
    const isEmptyState = query.length === 0;
    const url = new URL("https://www.google.com/maps/embed/v1/place");
    url.searchParams.append("key", apiKey);
    url.searchParams.append("q", query);
    url.searchParams.append("zoom", "15");
    return (_jsx(MapContainer, Object.assign({ isDesktop: !isMobile }, { children: _jsx(MapContainerBackground, Object.assign({ isDesktop: !isMobile }, { children: !isEmptyState ? (_jsxs(Fragment, { children: [_jsx(IconContainer, Object.assign({ isDesktop: !isMobile, isLoading: isLoading }, { children: isLoading && _jsx(Spinner, {}, void 0) }), void 0),
                    _jsx(MapIFrame, { allowFullScreen: true, frameBorder: "0", onLoad: () => setLoading(false), src: url.href, isDesktop: !isMobile }, void 0)] }, void 0)) : (_jsxs(Fragment, { children: [_jsx(WrapperSVGBackgroundMap, Object.assign({ isDesktop: !isMobile }, { children: _jsx(BackgroundMap, {}, void 0) }), void 0),
                    _jsxs(BackgroundInfo, { children: [_jsx(MapMarkerGreyFilled, {}, void 0),
                            _jsx(BackgroudTitle, Object.assign({ isDesktop: !isMobile }, { children: _jsx(Trans, { id: '"¿Tenés local? Agregá la dirección"' }, void 0) }), void 0)] }, void 0)] }, void 0)) }), void 0) }), void 0));
}
const IconContainer = styled.div(({ isLoading, isDesktop }) => (Object.assign(Object.assign({ bottom: "50%", height: "2.4rem", position: "absolute", right: "50%", transform: "translate(50%, 50%)" }, (isDesktop
    ? {
        height: "3.2rem",
    }
    : {})), { "& svg": Object.assign({ height: "2.4rem", position: "relative", transform: isLoading ? "" : "translateY(-50%)" }, (isDesktop
        ? {
            height: "3.2rem",
        }
        : {})) })));
const MapIFrame = styled.iframe(({ isDesktop }) => (Object.assign({ height: 212, width: "100%" }, (isDesktop
    ? {
        height: 340,
    }
    : {}))));
export const MapContainerBackground = styled.div(({ isDesktop }) => (Object.assign({ height: 212, position: "relative", width: "100%" }, (isDesktop
    ? {
        height: 340,
    }
    : {}))));
const MapContainer = styled.div(({ isDesktop }) => (Object.assign({}, (isDesktop
    ? {
        height: 340,
    }
    : {}))));
const BackgroudTitle = styled.span(({ isDesktop }) => (Object.assign({ fontFamily: "Open Sans, sans-serif", fontSize: "1.6rem" }, (isDesktop
    ? {
        fontSize: "2rem",
    }
    : {}))));
const WrapperSVGBackgroundMap = styled.span(({ isDesktop }) => ({
    "& svg": Object.assign({ height: 212, width: "100%" }, (isDesktop
        ? {
            height: 340,
        }
        : {})),
}));
const BackgroundInfo = styled.div(() => ({
    bottom: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    position: "absolute",
    right: "50%",
    transform: "translate(50%, 50%)",
    width: "fit-content",
    "& svg": {
        height: "4.8rem",
    },
}));
//# sourceMappingURL=Map.js.map